import { AuthenService } from "@/services/authen.service.ts";
import { CommonService } from "@/services/Common.service";

export class OsusumeService {
  private baseAPI = process.env.VUE_APP_API_URL;
  private commonAPI = process.env.VUE_APP_API_COMMON_URL;
  private commonService = new CommonService();

  constructor() {}

  async getCategory() {
    const { result, error } = await this.commonService.get(
      `${this.baseAPI}/admin/seibi-recommend-category`
    );
    if (result) {
      return result.data;
    } else {
      return error;
    }
  }

  addCategory(data: any) {
    return this.commonService.post(
      `${this.baseAPI}/admin/seibi-recommend-category`,
      data
    );
  }

  edtCategory(data: any) {
    return this.commonService.put(
      `${this.baseAPI}/admin/seibi-recommend-category`,
      data
    );
  }

  deleteCategory(id: number) {
    return this.commonService.delete(
      `${this.baseAPI}/admin/seibi-recommend-category/${id}`
    );
  }

  saveSeibiList(data: any) {
    return this.commonService.post(
      `${this.baseAPI}/admin/seibi-recommend`,
      data
    );
  }

  deleteSeibi(idSeibiOsusume: number) {
    return this.commonService.delete(
      `${this.baseAPI}/admin/seibi-recommend/${idSeibiOsusume}`
    );
  }

  deleteBuhin(idSeibiBuhinOsusume: number) {
    return this.commonService.delete(
      `${this.baseAPI}/admin/seibi-recommend-buhin/${idSeibiBuhinOsusume}`
    );
  }

  // 2022-01-31 morisako kobac-free add [START]
  async getCategoryBySknInspectSeibiFeeId(sknInspectSeibiFeeId: number) {
    const { result, error } = await this.commonService.get(
      `${this.baseAPI}/admin/seibi-recommend-category/${sknInspectSeibiFeeId}`
    );
    if (result) {
      return result.data;
    } else {
      return error;
    }
  }
  // 2022-01-31 morisako kobac-free add [END]
}
